// extracted by mini-css-extract-plugin
export default {"anchor":"styles__anchor___ew_WS","span":"styles__span___cK2TO","active":"styles__active___qjOxn"};